import { render, staticRenderFns } from "./ModaFormComponent.vue?vue&type=template&id=47abdd1c&scoped=true"
import script from "./ModaFormComponent.vue?vue&type=script&lang=js"
export * from "./ModaFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ModaFormComponent.vue?vue&type=style&index=0&id=47abdd1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47abdd1c",
  null
  
)

export default component.exports